import React, { useMemo, useEffect, useState, memo } from 'react'
import { useSelector } from 'react-redux'

import styled from 'styled-components'
import { useToasts } from 'react-toast-notifications'
import moment from 'moment'

import axiosInstance from '../../../../../services/config/AxiosIntance'

import Table from '../../../../../components/Table'
import Loader from '../../../../../components/Loader'
import Flex from '../../../../../components/layouts/Flex'
import DashboardItemTitle from '../../components/DashboardItemTitle'
import NoData from '../../components/NoData'

import CSVDownloader from '../../../../../lib/CSVDownloader'

const RoleStatusBreakdownList = () => {
  const { addToast } = useToasts()

  const filters = useSelector((state) => state.dashboard.filters)

  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [rowCount, setRowCount] = useState(0)

  const [loading, setLoading] = useState(false)
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    fetchData()
  }, [filters])

  const fetchData = async () => {
    try {
      setLoading(true)

      const queryParams = new URLSearchParams(filters).toString()
      const fetchedPageUrl = `/dashboard/role-status-breakdown/fetchPage?${queryParams}&pageNumber=${currentPage}&pageSize=${pageSize}`

      const result = await axiosInstance.get(fetchedPageUrl)

      setTableData(result?.data?.result?.data)

      setTotalPage(result?.data?.result?.pagination?.pageCount)
      setRowCount(result?.data?.result?.pagination?.rowCount)
      setCurrentPage(result?.data?.result?.pagination?.page)
      setPageSize(result?.data?.result?.pagination?.pageSize)
    } catch (error) {
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    try {
      const queryFilter = {
        dates: filters?.dates?.toString(),
      }
      const queryParams = new URLSearchParams(queryFilter).toString()
      const url = `/dashboard/role-status-breakdown/fetchAll?${queryParams}&pageNumber=${currentPage}&pageSize=${pageSize}`
      const result = await axiosInstance.get(url)
      const response = result?.data?.result?.data.map((e) => ({
        Role: e.role,
        Client: e.client,
        'Recruitment Type': e.recruitment_type_name,
        'Initiation Date': moment(e.date_posted).format('MM/DD/YYYY'),
        'Ageing Days': e.ageing_days,
      }))
      CSVDownloader.downloadUnparsedCSV(
        response,
        'Role_Status_Breakdown_List.csv'
      )
    } catch (error) {
      console.log(error)
      addToast('Something went wrong', {
        appearance: 'error',
        autoDismiss: true,
      })
    }
  }

  const tableColumns = useMemo(
    () => [
      {
        Header: 'Role',
        accessor: 'role',
      },
      {
        Header: 'Client',
        accessor: 'client',
      },
      {
        Header: 'Recruitment Type',
        accessor: 'recruitment_type_name',
      },
      {
        Header: 'Initiation Date',
        accessor: 'date_posted',
        Cell: ({ value }) => (value ? moment(value).format('MM/DD/YYYY') : ''),
        sortType: 'datetime',
      },
      {
        Header: 'Ageing Days',
        accessor: 'ageing_days',
      },
    ],
    []
  )

  return (
    <StyledRoleStatusBreakdownList>
      <Flex justify="space-between">
        <DashboardItemTitle title="Role Status Breakdown List" />
        <Flex gap="0.5rem">
          <ExportButton onClick={handleExport}>Export</ExportButton>
        </Flex>
      </Flex>

      {loading && <Loader />}

      {tableData?.length > 0 ? (
        <Table
          height="100%"
          totalPage={totalPage}
          currentPage={currentPage}
          pageSize={pageSize}
          rowCount={rowCount}
          data={tableData}
          columns={tableColumns}
          setNewPageSize={setPageSize}
          setCurrentPage={setCurrentPage}
          fetchData={fetchData}
          onClick={() => null}
        ></Table>
      ) : (
        <NoData />
      )}
    </StyledRoleStatusBreakdownList>
  )
}

export default memo(RoleStatusBreakdownList)

const StyledRoleStatusBreakdownList = styled.div`
  width: 100%;
  height: 100%;
`
const ExportButton = styled.button`
  padding: 0.35rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: black;
  color: white;
  border-radius: 100px;
  word-spacing: 3px;
`
